// Mock data for Eco Enviro Engineers website

export const services = [
  {
    id: 1,
    title: "Environmental Planning & Sustainability",
    description: "Comprehensive environmental impact assessments, sustainability strategies, and eco-friendly solutions tailored to your project needs.",
    icon: "Leaf",
    image: "https://images.unsplash.com/photo-1655975719898-8f3432eed322?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxjaXZpbCUyMGVuZ2luZWVyaW5nJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3MDcyMzE1NHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Civil & Structural Engineering",
    description: "Expert structural design, analysis, and engineering solutions for residential, commercial, and industrial projects.",
    icon: "Building2",
    image: "https://images.pexels.com/photos/19370588/pexels-photo-19370588.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Drafting & Design Services",
    description: "Precision CAD drafting, 3D modeling, and technical design documentation for all engineering disciplines.",
    icon: "PenTool",
    image: "https://images.pexels.com/photos/3862384/pexels-photo-3862384.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 4,
    title: "MEP Engineering",
    description: "Integrated mechanical, electrical, and plumbing design solutions optimized for efficiency and sustainability.",
    icon: "Cog",
    image: "https://images.unsplash.com/photo-1655612669820-b71e69fba494?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxjaXZpbCUyMGVuZ2luZWVyaW5nJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3MDcyMzE1NHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Project Management & Advisory",
    description: "End-to-end project management, technical consulting, and strategic advisory services for complex engineering projects.",
    icon: "ClipboardCheck",
    image: "https://images.unsplash.com/photo-1706437524158-6ca925ce5a06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxpbmZyYXN0cnVjdHVyZSUyMGRldmVsb3BtZW50fGVufDB8fHx8MTc3MDcyMzE1OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Health & Safety Systems",
    description: "Comprehensive workplace safety assessments, risk mitigation strategies, and compliance management.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1746364742672-c6383331b032?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxpbmZyYXN0cnVjdHVyZSUyMGRldmVsb3BtZW50fGVufDB8fHx8MTc3MDcyMzE1OHww&ixlib=rb-4.1.0&q=85"
  }
];

export const projects = [
  {
    id: 1,
    title: "Sustainable Transit Infrastructure",
    category: "Infrastructure",
    description: "Modern elevated rail system designed for efficiency and minimal environmental impact.",
    image: "https://images.unsplash.com/photo-1759111135279-a5c517599412",
    year: "2024"
  },
  {
    id: 2,
    title: "Green Building Integration",
    category: "Environmental",
    description: "Award-winning sustainable architecture with integrated vertical gardens and eco-friendly systems.",
    image: "https://images.unsplash.com/photo-1556983852-43bf21186b2a",
    year: "2024"
  },
  {
    id: 3,
    title: "Advanced Transportation Hub",
    category: "Infrastructure",
    description: "Cutting-edge monorail system demonstrating innovation in public transportation engineering.",
    image: "https://images.unsplash.com/photo-1770123366825-302bf4f50138",
    year: "2023"
  },
  {
    id: 4,
    title: "Multi-Level Highway System",
    category: "Core Sector",
    description: "Complex elevated road and bridge infrastructure optimizing urban traffic flow.",
    image: "https://images.unsplash.com/photo-1759494930316-25629c5ea763",
    year: "2023"
  },
  {
    id: 5,
    title: "Eco-Conscious Corporate Campus",
    category: "Environmental",
    description: "LEED-certified commercial building with integrated green spaces and sustainable design.",
    image: "https://images.unsplash.com/photo-1451976426598-a7593bd6d0b2",
    year: "2023"
  },
  {
    id: 6,
    title: "Contemporary Engineering Complex",
    category: "Infrastructure",
    description: "Modern architectural masterpiece showcasing advanced structural engineering principles.",
    image: "https://images.unsplash.com/photo-1496564203457-11bb12075d90",
    year: "2022"
  }
];

export const sectors = [
  {
    id: 1,
    name: "Environmental",
    icon: "Trees",
    description: "Sustainable solutions for environmental challenges"
  },
  {
    id: 2,
    name: "Infrastructure",
    icon: "Layers",
    description: "Modern infrastructure design and development"
  },
  {
    id: 3,
    name: "Core Sectors",
    icon: "Factory",
    description: "Industrial and manufacturing engineering"
  },
  {
    id: 4,
    name: "Commercial",
    icon: "Building",
    description: "Commercial building and facility solutions"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Technical Excellence",
    description: "Multidisciplinary expertise across all engineering domains with proven track record of delivering complex projects.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Collaborative Partnerships",
    description: "Strategic collaborations with industry leaders to provide comprehensive, end-to-end solutions.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Quality Assurance",
    description: "Rigorous quality management systems ensuring the highest standards in every deliverable.",
    icon: "CheckCircle2"
  },
  {
    id: 4,
    title: "Safety First",
    description: "Unwavering commitment to workplace safety and regulatory compliance across all projects.",
    icon: "ShieldCheck"
  },
  {
    id: 5,
    title: "Sustainability Focus",
    description: "Environmental stewardship integrated into every project phase, minimizing ecological impact.",
    icon: "Sprout"
  },
  {
    id: 6,
    title: "Continuous Innovation",
    description: "Ongoing investment in learning, technology, and innovative solutions to stay ahead of industry trends.",
    icon: "Lightbulb"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Project Director, Urban Development Corp",
    content: "Eco Enviro Engineers delivered exceptional results on our sustainable infrastructure project. Their technical expertise and commitment to environmental standards exceeded our expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "David Chen",
    role: "CEO, GreenTech Industries",
    content: "The team's collaborative approach and attention to detail made our complex MEP integration seamless. True professionals who understand both engineering and sustainability.",
    rating: 5
  },
  {
    id: 3,
    name: "Emma Rodriguez",
    role: "Facilities Manager, Metro Transit Authority",
    content: "Outstanding project management and technical advisory services. They simplified complex challenges and delivered innovative solutions on time and within budget.",
    rating: 5
  }
];

export const stats = [
  { id: 1, value: "500+", label: "Projects Completed" },
  { id: 2, value: "15+", label: "Years Experience" },
  { id: 3, value: "98%", label: "Client Satisfaction" },
  { id: 4, value: "50+", label: "Expert Partners" }
];
